import React from 'react';

export default (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 80 38"
    name="company"
    role="img"
    aria-label="company"
  >
    <g clip-path="url(#a)">
      <path fill="#FAF5EF" d="M0 0h80v38H0z" />
      <path fill="#EEE7DE" d="M0 17.585 18.378 6.973V0H3.669L0 2.117v15.468Z" />
      <path fill="#EEE7DE" d="M57.433 0h-31.27L0 15.061v10.443L21.708 38H66.46L80 30.206V12.99L57.433.001Z" />
      <path
        fill="#222120"
        d="M0 4.644 8.066 0h.867L0 5.142v-.498Zm80 31.578L76.912 38h-.867L80 35.723v.5ZM51.347 0 80 16.495v.499L50.48 0h.867Z"
      />
      <path fill="#FBF8F7" d="M59.544 38H23.87L0 23.99v-9.724L25.614 0H36.19L76.5 23.3V28L59.544 38Z" />
      <path
        fill="#000"
        d="M0 13.98 25.1 0h1.027L0 14.552v-.572ZM23.377 38 0 24.279v-.58L24.364 38h-.988ZM36.69 0l39.935 23.084a.25.25 0 0 1 .125.216V28a.25.25 0 0 1-.123.215L60.036 38h-.985L76.25 27.857v-4.122L51.742 38h-.994l25.254-14.7L35.69 0h.999Z"
      />
      <path fill="#F0EAE1" d="M59.544 38h-8.3L76.5 23.3V28L59.544 38Z" />
      <path
        fill="#000"
        d="m60.036 38 16.591-9.785A.25.25 0 0 0 76.75 28v-4.7a.25.25 0 0 0-.376-.216L50.748 38h.994L76.25 23.735v4.122L59.051 38h.985Z"
      />
      <path fill="#FAF5EF" d="M53.79 0H17.125L35.5 10.5 53.79 0Z" />
      <path fill="#222120" d="M54.292 0 35.624 10.717a.25.25 0 0 1-.248 0L16.621 0h1.008l17.87 10.212L53.29 0h1.003Z" />
      <path fill="#FBF8F7" d="M33.797 38H35.5V10.5L17.125 0H4v20.5L33.797 38Z" />
      <path fill="#F0EAE1" d="M17.125 0h-5.25L35.5 13.5v-3L17.125 0Z" />
      <path
        fill="#000"
        d="M33.304 38 3.874 20.716a.25.25 0 0 1-.124-.216V0h.5v20.357L34.291 38h-.987ZM17.629 0l17.995 10.283a.25.25 0 0 1 .126.217V38h-.5V10.645L16.621 0h1.008Z"
      />
      <path fill="#F0EAE1" d="M62.5 0v23.5L37.242 38H35.5V10.5L53.79 0h8.71Z" />
      <path
        fill="#000"
        d="M35.25 38V10.5a.25.25 0 0 1 .126-.217L53.288 0h1.005L35.75 10.645V38h-.5Zm27.5-38v23.5a.25.25 0 0 1-.126.217L37.745 38H36.74l25.51-14.645V0h.5Z"
      />
      <path
        fill="#DACEC3"
        d="m38.216 15.498 2.794-1.614-.016 6.418-2.794 1.614.016-6.418Zm4.77-2.778 2.794-1.613-.016 6.418-2.795 1.613.017-6.418Zm4.799-2.769 2.794-1.613-.016 6.418-2.794 1.613.016-6.418Zm4.8-2.769 2.794-1.613-.016 6.418-2.795 1.613.017-6.418Zm4.799-2.769L60.178 2.8l-.016 6.418-2.794 1.614.016-6.419ZM38.216 25.097l2.794-1.614-.016 6.418-2.794 1.614.016-6.418Zm4.77-2.778 2.794-1.613-.016 6.418-2.795 1.613.017-6.418Zm4.799-2.769 2.794-1.613-.016 6.418-2.794 1.613.016-6.418Zm4.799-2.769 2.795-1.613-.016 6.418-2.795 1.613.017-6.418Zm4.8-2.769 2.794-1.613-.016 6.418-2.794 1.613.016-6.418Z"
      />
      <path
        fill="#EEE7DE"
        d="m31.655 14.918-1.976-1.141.045 17.861 1.977 1.14-.046-17.86Zm-3.663-2.111-1.976-1.14.046 18.012 1.976 1.14-.046-18.011Zm-3.662-2.11-1.977-1.141.046 18.147 1.976 1.14-.046-18.146Zm-3.664-2.121L18.69 7.435l.046 18.183 1.976 1.141-.046-18.183Zm-3.663-2.115-1.976-1.14.046 18.124 1.976 1.14-.046-18.124ZM13.34 4.348l-1.976-1.14.046 18.116 1.976 1.141-.045-18.117ZM9.676 2.241 7.7 1.1l.046 18.182 1.976 1.141-.046-18.182ZM30.712 0h2.36l.005 1.923L30.715.558 30.712 0Zm14.213 0-9.486 5.477L35.453 0h9.472Z"
      />
      <path fill="#FAF5EF" d="m40.153 0-.003 1.065-2.364 1.364L37.792 0h2.36ZM0 30.777V13.365l15.123 8.706L0 30.777Z" />
      <path fill="#222120" d="m0 31.276 15.557-8.956v-.498L0 12.866v.5l15.123 8.705L0 30.777v.499Z" />
      <path fill="#F9F5F0" d="M0 37.262V31.04l15.235-8.796v6.223L0 37.262Z" />
      <path
        fill="#222120"
        d="m0 37.512 15.235-8.796.216-.375v-6.223l-.216-.125L0 30.789v.5l15.018-8.671v5.723L0 37.012v.5Z"
      />
      <path fill="#EEE7DE" d="M15.234 38H0v-.733l15.235-8.797V38Z" />
      <path fill="#222120" d="m15.45 38 .001-9.654-.216-.125L0 37.017v.5l15.018-8.672V38h.433Z" />
      <path fill="#FAF5EF" d="M12.672 38H5.5l7.173-4.142V38Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h80v38H0z" />
      </clipPath>
    </defs>
  </svg>
);
